module.exports = __webpack_public_path__ + "img/a75ec365f3ddbdbafbd6e48c704787ab.png";